import axios from "axios";
import submitCredentialsDevData, { type SubmitCredentialsResponse } from "./dev-data/submitCredentials";
import submitMfaMethodDevData, {
	type SubmitMfaMethodResponse,
} from "./dev-data/submitMfaMethod";
import submitMfaCodeDevData, {
	type SubmitMfaCodeResponse,
} from "./dev-data/submitMfaCode";
import sessionStatusDevData, {
	type GetSessionStatusResponse,
	type UserAccount,
} from "./dev-data/getSessionStatus";
import endSessionDevData, { type EndSessionResponse } from "./dev-data/endSession";
import submitAuthorizedAccountsDevData, {
	type SubmitAuthorizedAccountsResponse,
} from "./dev-data/submitAuthorizedAccounts";
import type { SessionStatus } from "../store/appStore";
import resendMfaCodeDevData,  {  type ResendMfaCodeResponse } from "./dev-data/resendMfaCode";
import changeMfaMethodDevData, {
	type ChangeMfaMethodResponse,
} from "./dev-data/changeMfaCode";

const api = axios.create({
  baseURL: "/api/public/v1/utility-authz/pge",
});

export const testMode = false;

export const submitCredentials = async (username: string, password: string): Promise<SubmitCredentialsResponse> => {
  if (!testMode) {
    const response = await api.post<SubmitCredentialsResponse>("/session/create", { username, password });
    return response.data;
  } else {
    return submitCredentialsDevData;
  }
};

export const endSession = async (sessionId: string, success: boolean = false) => {
  if (!testMode) {
    const basePath = `/session/${sessionId}/end`;
    const response = await api.put<EndSessionResponse>(success ? `${basePath}/success` : basePath);
    return response.data;
  } else {
    return endSessionDevData;
  }
};

export const submitMfaMethod = async (sessionId: string, mfaMethodType: 'EMAIL' | 'SMS') => {
  if (!testMode) {
    const response = await api.put<SubmitMfaMethodResponse>(`/session/${sessionId}/mfaMethod/${mfaMethodType}`);
    return response.data;
  } else {
    return submitMfaMethodDevData;
  }
};

export const submitMfaCode = async (sessionId: string, mfaCode: string) => {
  if (!testMode) {
    const response = await api.put<SubmitMfaCodeResponse>(`/session/${sessionId}/mfaCode/${mfaCode}`);
    return response.data;
  } else {
    return submitMfaCodeDevData;
  }
};

export const resendMfaCode = async (sessionId: string) => {
  if (!testMode) {
    const response = await api.put<ResendMfaCodeResponse>(`/session/${sessionId}/mfaCodeResend`);
    return response.data;
  } else {
    return resendMfaCodeDevData;
  }
};

export const changeMfaMethod = async (sessionId: string) => {
  if (!testMode) {
    const response = await api.put<ChangeMfaMethodResponse>(`/session/${sessionId}/changeMfaMethod`);
    return response.data;
  } else {
    return changeMfaMethodDevData;
  }
}

export const submitAuthorizedAccounts = async (sessionId: string, userAccounts: UserAccount[]) => {
  if (!testMode) {
    const response = await api.post<SubmitAuthorizedAccountsResponse>(`/session/${sessionId}/submitAuthAuthorizedAccounts`, { userAccounts });
    return response.data;
  } else {
    return submitAuthorizedAccountsDevData;
  }
};

export const getSessionStatus = async (sessionId: string): Promise<GetSessionStatusResponse> => {
  console.info({ getSessionStatus: { sessionId } });
  if (!testMode) {
    const response = await api.get<GetSessionStatusResponse>(`/session/${sessionId}/status`);
    return response.data;
  } else {
    return sessionStatusDevData;
  }
};

export const jumpToSessionStatus = async (sessionId: string, status: SessionStatus): Promise<GetSessionStatusResponse> => {
  if (!testMode) {
    const response = await api.put<GetSessionStatusResponse>(`/session/${sessionId}/jumpToStatus/${status}`);
    return response.data;
  } else {
    return sessionStatusDevData;
  }
};

export default api;
